module.exports = __webpack_public_path__ + "img/benoit8.0b99038b.jpg";